import { Fragment } from 'react';
import { Box, Button, Chip } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import QueryRuleGroup from '../../../../Clients/QueryBuilder/components/QueryRuleGroup';
import type { TargetingBuilder } from './useTargetingBuilder';

function AdvancedRuleGroups({ builder }: { builder: TargetingBuilder['advanced'] }) {
  const { groups, categories, fields, addRule, updateRule, removeRule, removeGroup, addGroup } = builder;

  return (
    <>
      {groups.map((group, index) => (
        <Fragment key={group.id}>
          <QueryRuleGroup
            group={group}
            categories={categories}
            fields={fields}
            onAddRule={addRule}
            onUpdateRule={updateRule}
            onRemoveRule={removeRule}
            onRemoveGroup={removeGroup}
            showCombinator={index > 0}
            canRemoveGroup={groups.length > 1}
          />
          {index < groups.length - 1 && (
            <Box sx={{ textAlign: 'center', my: 2 }}>
              <Chip label="OU" sx={{ bgcolor: 'warning.light', color: 'common.white', fontWeight: 600 }} />
            </Box>
          )}
        </Fragment>
      ))}

      {groups.length < 2 && (
        <Button
          fullWidth
          variant="outlined"
          size="small"
          startIcon={<AddIcon />}
          onClick={addGroup}
          sx={{ mt: 1, textTransform: 'none', borderColor: 'primary.main', color: 'primary.main', borderStyle: 'dashed' }}
        >
          Ajouter un groupe (OU)
        </Button>
      )}
    </>
  );
}

export default AdvancedRuleGroups;
